/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { z } from 'zod'
import { checkUserName } from './authQueryOptions'

export enum Role {
  'Front-Desk' = 'Front-Desk',
  'Editor' = 'Editor',
  'Organizator' = 'Organizator',
  'Reseller' = 'Reseller',
  'Internal' = 'Internal',
  'Blogger' = 'Blogger',
  'PropertyManager' = 'PropertyManager'
}

export type UserRole = {
  id: string
  name: Role
  description: string
}

export const loginFormSchema = z.object({
  username: z.string().trim().min(1),
  password: z
    .string()
    .min(6, { error: 'Password must be at least 6 characters' })
    .max(25, { error: 'Password must be at most 20 characters' }),
})

export type LoginFormValues = z.infer<typeof loginFormSchema>

export const userFormSchema = z
  .object({
    firstName: z.string().min(2),
    lastName: z.string().min(2),
    email: z.email(),
    phone: z.string().optional(),
    role: z.enum(Role),
    profilePicture: z.string().optional(),
    username: z.string().refine(
      async (value) => {
        const response = await checkUserName(value)
        // If there is no response or there is an error, return false
        return response && response.success
      },
      {
        message: 'Error on validating username',
      }
    ),
    entityIds: z.array(z.string()).optional(),
    organizationId: z.string().optional(),
    resellerId: z.string().optional(),
  })
  .check((ctx) => {
    if (
      (ctx.value.role === Role['Front-Desk'] ||
        ctx.value.role === Role.Editor ||
        ctx.value.role === Role.PropertyManager) &&
      ctx.value.entityIds?.length === 0
    ) {
      ctx.issues.push({
        code: 'custom',
        path: ['entityIds'],
        message: 'Select at least one property',
        input: ctx.value,
      })
    }
    if (ctx.value.role === Role['Organizator'] && !ctx.value.organizationId) {
      ctx.issues.push({
        code: 'custom',
        path: ['organizationId'],
        message: 'Select an organization',
        input: ctx.value,
      })
    }
  })

export type UserFormValues = z.infer<typeof userFormSchema>
export type UserFormInputValues = z.input<typeof userFormSchema>

export const userSchema = z.object({
  id: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  email: z.email(),
  phone: z.string().optional(),
  role: z.enum(Role),
  username: z.string(),
  resellerName: z.string(),
  resellerId: z.string().optional(),
  signInId: z.string().optional(),
  internal: z.boolean().optional(),
  entityIds: z.array(z.string()).optional(),
  organizationName: z.string(),
  organizationId: z.string().optional(),
  profilePicture: z.string(),
})

export type User = z.infer<typeof userSchema>

export type LoginResponse = {
  message: string
  user: User
  accessToken: string
  refreshToken: string
}

export const userUpdateFormSchema = z.object({
  firstName: z.string().min(2),
  lastName: z.string().min(2),
  phone: z.string().optional(),
  profilePicture: z.string().optional(),
})
export type UserUpdateFormValues = z.infer<typeof userUpdateFormSchema>
